import { DefaultTheme } from 'styled-components';

import common from './common';
import device from './device';
import font from './font';
import gradient from './gradient';
import gray from './gray';
import shadows from './shadow';
import system from './system';
import typo from './typo';

const Theme: DefaultTheme = {
	colors: {
		gray,
		system,
		primary: {
			primary10_lighten: '#E2EDFF',
			primary15: '#CEE1FF',
			primary20: '#BBD6FF',
			primary30: '#93BEFF',
			primary40: '#6CA6FF',
			primary50_key: '#458EFF',
			primary60: '#0060F6',
			primary70: '#0051CE',
			primary80_darken: '#0042A7',
			primary90: '#003280',
			primary95: '#002359',
		},
		uplus: {
			primary05: '#ffe0f5',
			primary10_lighten: '#fec8e8',
			primary15: '#ffacdd',
			primary20: '#fe91d2',
			primary30: '#ff5abb',
			primary40: '#ff22a5',
			primary50_key: '#FF5452',
			// primary50_key: '#bb0841',
			primary60: '#bc006f',
			primary70: '#8c0053',
			primary80_darken: '#5e0037',
			primary90: '#2e001b',
			primary95: '#17000d',
			bg10_lighten: '#F9F9F9',
			bg15: '#F2F2F2',
			bg20: '#ECECEC',
			bg30: '#D9D9D9',
			bg40: '#C6C6C6',
			bg50_key: '#EEECE9',
			bg60: '#B3B3B3',
			bg70: '#999999',
			bg80_darken: '#808080',
			bg90: '#666666',
			bg95: '#4D4D4D',
		},
	},
	typo,
	font,
	shadow: shadows.shadow,
	drop_shadow: shadows.drop_shadow,
	gradient,
	common,
	device,
};

export { Theme };
